// extracted by css-extract-rspack-plugin
export default {"tile":"src-features-Responder-features-Messenger-components-VideoTile-module__tile-GFjC7N","video":"src-features-Responder-features-Messenger-components-VideoTile-module__video-PC0QnJ","mirrored":"src-features-Responder-features-Messenger-components-VideoTile-module__mirrored-XC4btB","muteBadge":"src-features-Responder-features-Messenger-components-VideoTile-module__muteBadge-TN0xB7"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"tile\":\"src-features-Responder-features-Messenger-components-VideoTile-module__tile-GFjC7N\",\"video\":\"src-features-Responder-features-Messenger-components-VideoTile-module__video-PC0QnJ\",\"mirrored\":\"src-features-Responder-features-Messenger-components-VideoTile-module__mirrored-XC4btB\",\"muteBadge\":\"src-features-Responder-features-Messenger-components-VideoTile-module__muteBadge-TN0xB7\"}";
        // 1790730173217
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  